module.exports = {
  ra: {
    action: {
      add_filter: 'Add Search Condition',
      add: 'Add',
      back: 'Go Back',
      bulk_actions: '1 item selected |||| %{smart_count} items selected',
      cancel: 'Cancel',
      clear_input_value: 'Clear value',
      clone: 'Clone',
      confirm: 'Confirm',
      confirm_leave: 'Leave Page',
      confirm_quit: 'Quit',
      create: 'Create',
      delete: 'Delete',
      edit: 'Edit',
      export: 'Export',
      list: 'List',
      refresh: 'Refresh',
      remove_filter: 'Remove this filter',
      remove: 'Remove',
      save: 'Save',
      search: 'Search',
      show: 'Show',
      sort: 'Sort',
      undo: 'Undo',
      unselect: 'Unselect',
      expand: 'Expand',
      close: 'Close',
      loading_list: 'The list of %{listName} is loading, just a moment please'
    },
    boolean: {
      true: 'Yes',
      false: 'No',
      null: 'Empty'
    },
    page: {
      create: 'Create %{name}',
      dashboard: 'Dashboard',
      edit: '%{name} #%{id}',
      error: 'Something went wrong',
      list: '%{name}',
      loading: 'Loading',
      not_found: 'Not Found',
      show: '%{name} #%{id}'
    },
    input: {
      file: {
        upload_several: 'Drop some files to upload, or click to select one.',
        upload_single: 'Drop a file to upload, or click to select it.'
      },
      image: {
        upload_several: 'Drop some pictures to upload, or click to select one.',
        upload_single: 'Drop a picture to upload, or click to select it.'
      },
      references: {
        all_missing: 'Unable to find references data.',
        many_missing:
          'At least one of the associated references no longer appears to be available.',
        single_missing:
          'Associated reference no longer appears to be available.'
      },
      password: {
        toggle_hidden: 'Hidden'
      }
    },
    message: {
      about: 'About',
      are_you_sure: 'Are you sure?',
      no_edit_permission:
        'No changes were saved - you do not have appropriate privileges.',
      bulk_delete_content:
        'Are you sure you want to delete this %{name}? |||| Are you sure you want to delete these %{smart_count} items?',
      bulk_delete_title:
        'Delete %{name} |||| Delete %{smart_count} %{name} items',
      delete_content:
        'The %{name} will be permanently deleted. You can not undo this action.',
      delete_title: 'Delete this %{name}',
      details: 'Details',
      error: "A client error occurred and your request couldn't be completed.",
      invalid_form: 'Please check for errors before proceeding.',
      loading: 'The page is loading, just a moment please',
      loading_table: 'The table is loading, just a moment please',
      no: 'No',
      not_found: 'Either you typed a wrong URL, or you followed a bad link.',
      yes: 'Yes',
      confirm_copy:
        'Are you sure you want to copy the instructions on this page to all funds for this investor. Doing so will erase whatever instructions are assigned for the other funds and replace it with this one. Do you want to proceed ?',
      confirm_delete_tags:
        'Are you sure you want to delete this %{name}? All related links will be removed. |||| Are you sure you want to delete these %{smart_count} items? All related links will be removed.',
      confirm_delete_tag:
        'The %{name} will be permanently deleted. You can not undo this action. All related links will be removed.',
      fund_level_document:
        '(Document is visible from all investors of the selected funds, selecting a pool of investors via tags is disabled)'
    },
    navigation: {
      no_results: 'No results found',
      no_more_results:
        'The page number %{page} is out of boundaries. Try the previous page.',
      page_out_of_boundaries: 'Page number %{page} out of boundaries',
      page_out_from_end: 'Cannot go after last page',
      page_out_from_begin: 'Cannot go before page 1',
      page_range_info: '%{offsetBegin}-%{offsetEnd} of %{total}',
      page_rows_per_page: 'Rows per page:',
      next: 'Next',
      prev: 'Prev'
    },
    auth: {
      auth_check_error: 'Please login to continue',
      user_menu: 'Profile',
      username: 'Username',
      password: 'Password',
      sign_in: 'Sign in',
      sign_in_error: 'Authentication failed, please retry',
      logout: 'Logout'
    },
    notification: {
      updated:
        'Changes were saved successfully |||| %{smart_count} changes were saved successfully',
      custom_updated_message: 'Changes were saved successfully',
      importation_permission_groups:
        'Permission Groups have been successfully Imported.',
      copy_contacts_successfull: 'Contacts copied successfully',
      created_contact_successful: 'Contact was successfully created.',
      created_investor_successful: 'Investor was successfully created',
      created: 'Item was created successfully',
      deleted:
        'Item was deleted successfully |||| %{smart_count} items were deleted successfully',
      added:
        'Item was added successfully |||| %{smart_count} items were added successfully',
      bad_item: 'Incorrect element',
      item_doesnt_exist: 'Element does not exist',
      http_error: 'Server communication error',
      data_provider_error: 'dataProvider error. Check the console for details.',
      canceled: 'Action cancelled',
      logged_out: 'Your session has ended, please reconnect.',
      password_reset:
        'Password was reset. Email with new temporary password has been sent.',
      set_password_updated: 'Temporary password created successfully.',
      send_envelopes:
        'Envelope was sent successfully |||| %{smart_count} Envelopes were sent successfully',
      udfs_successfully_updated: 'Properties successfully updated',
      group_created:
        'To complete the process of adding a new permission group the next step must be completed by selecting the document categories that should be mapped to this new group. Click on the Related Categories and Subcategories option once the group is created to make your selections.',
      distribution_email_sent:
        'Email send Initiated - check the email archive for the status',
      server: '%{message}',
      distribution_list_updated: 'Distribution list updated successfully',
      watermark_text_direction:
        'Watermark Text Direction cannot be empty if Direction is chosen.',
      watermark_text_position:
        'Watermark Text Position cannot be empty if Position is chosen.',
      delete_error: 'Error: Items was not deleted',
      resource_upload_pending: 'Your document has been set as Pending',
      resource_upload_approved: 'Your document has been approved',
      resource_upload_approved_email:
        'Your document has been approved and email was sent successfully',
      copy_wire_instructions: 'Wire Instructions successfully copied',
      update_primary_contacts_successfull:
        'Primary Contacts were successfully updated',
      report_has_more_data:
        "The report has reached it's maximum output. Please change your filter selection to get different results.",
      report_has_bad_criteria:
        'The report contains filter criteria that is not supported. One of the filters used must contain only one value checked/selected.',
      date_after_today: 'Cannot be set after current date'
    },
    validation: {
      required: 'Required',
      minLength: 'Must be %{min} characters at least',
      maxLength: 'Must be %{max} characters or less',
      minValue: 'Must be at least %{min}',
      maxValue: 'Must be %{max} or less',
      number: 'Must be a number',
      email: 'Must be a valid email',
      oneOf: 'Must be one of: %{options}',
      regex: 'Must match a specific format (regexp): %{pattern}'
    },
    log: {
      error: 'An error occurred.. (error-ID: %{logId} %{message})'
    },
    network: {
      http_error:
        'Server communication error (%{status}). Create in ra.network._%{status}',
      _504: 'The request took too long and timed out. (504)'
    }
  },
  resources: {
    organizations: {
      empty: 'No results fund',
      name: 'Investor Family'
    },
    splitmethods: {
      name: 'Split Method'
    },
    users: {
      name: 'Contact'
    },
    fundfamilies: {
      name: 'Fund Family'
    },
    funds: {
      name: 'Fund'
    },
    investors: {
      name: 'Investor'
    },
    resourceuploads: {
      name: 'Document Management'
    },
    documenttypes: {
      name: 'Document Type'
    },
    categories: {
      name: 'Document Category'
    },
    documentpresets: {
      name: 'Document Profile'
    },
    documentwatermarks: {
      name: 'Watermark Profile'
    },
    groups: {
      name: 'Permission Group'
    },
    roles: {
      name: 'Access Role'
    },
    fundterms: {
      name: 'Fund Terms'
    },
    categoryterms: {
      name: 'Category Terms'
    },
    mailtemplates: {
      name: 'Email Template'
    },
    distributionlists: {
      name: 'Distribution List'
    },
    categorytermsrelations: {
      name: 'Category Terms Relationship'
    },
    fundtermsrelations: {
      name: 'Fund Terms Relationship'
    },
    authorities: {
      name: 'Authority'
    },
    userphones: {
      name: 'Phone Number'
    },
    useraddresses: {
      name: 'Address'
    },
    userphonetypes: {
      name: 'Phone type'
    },
    useraddresstypes: {
      name: 'Address type'
    },
    userauthorizations: {
      name: 'Authorization'
    },
    userroles: {
      name: 'Role'
    },
    subcategories: {
      name: 'Subcategory'
    },
    fundinvestors: {
      name: 'Fund Investor Relationship'
    },
    groupcategories: {
      name: 'Group Category Relationship'
    },
    wireinstructions: {
      name: 'Wire Instruction'
    },
    fundtags: {
      name: 'Fund Tag'
    },
    investortags: {
      name: 'Investor Tag'
    },
    fundinvestortags: {
      name: 'Fund-Investor Tag'
    }
  }
};
